export var recordStyle = {
  gridColumn: '1/3',
  alignItems: 'stretch',
  borderBottom: '1px solid',
  borderColor: 'gray.200',
  mx: 6,
  py: 2
};